// §9.5 — consolidation engine client. Both routes are business-scoped and take
// NO request body (the BE works off the session's authorized, not-yet-linked
// orders). preview is read-only; bulk-create is wrapped in withIdempotency.
import { v4 as uuidv4 } from "uuid"
import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

const idem = (): Record<string, string> => ({ "Idempotency-Key": uuidv4() })

export interface IConsolidationPreviewItem {
  bucketKey: string
  orderIds: string[]
  receiverBusinessId: string | null
  deliveryDate: string | null
  shipToAddress: string | null
}

export interface IConsolidationPreviewResult {
  buckets: IConsolidationPreviewItem[]
  totalOrders: number
  totalDnsToCreate: number
}

export interface IConsolidationCommitResult {
  dnsCreated: number
  ordersConsolidated: number
  deliveryNoteIds: string[]
}

export const preview = async (): Promise<IConsolidationPreviewResult> => {
  return httpRequest.post("/ord/consolidation/preview", {})
}

export const bulkCreate = async (): Promise<IConsolidationCommitResult> => {
  return httpRequest.post("/ord/consolidation/bulk-create", {}, idem())
}
